import { PersonTypes } from '@frontend/api-person';
import { InsuranceContainer } from './insurance-container';
import { UndefinedOrNull } from './utils/types';

interface Props {
  locationId: string;
  personInfo: UndefinedOrNull<PersonTypes.Person>;
}

export const InsuranceTab = ({ locationId, personInfo }: Props) => {
  return <InsuranceContainer locationId={locationId} personInfo={personInfo} />;
};
InsuranceTab.displayName = 'InsuranceTab';
